// extracted by mini-css-extract-plugin
module.exports = {"naver":"ProductNav_naver__5mdi0"};